import core from '../modules/core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
  getMyCstmrList(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/getMyCstmrList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  saveMyCustBkmr(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/saveMyCustBkmr',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  deleteCustBkmr(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/deleteCustBkmr',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  saveMyCustList(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/saveMyCustList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  getSavedCustMasterList(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/getSavedCustMasterList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  deleteSavedCustList(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/deleteSavedCustList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  getSmsTempleteList(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/getSmsTempleteList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  sendSms(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/sendSms',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  getProdMstList() {
    return core.call({
      url: '/api/v1/mycstmr/getProdMstList',
      method: 'post',
      data: '',
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  getMyCstmr(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/getMyCstmr',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  gelectMyCstmrDiagnosisList(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/gelectMyCstmrDiagnosisList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  cmplMyCstmrVoc(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/cmplMyCstmrVoc',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  saveMyCustMemo(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/saveMyCustMemo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  deleteCustMemo(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/deleteCustMemo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  getCustMemoList(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/getCustMemoList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  getCustFamilyList(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/getCustFamilyList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  getInterestInfoList(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/getInterestInfoList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  shareResult(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/shareResult',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  saveMyCstmr(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/saveMyCstmr',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  saveCustAthn(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/saveCustAthn',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  validAuthNo(parameters={}) {
    return core.call({
      url: '/api/v1/external/validAuthNo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  issueAuthNo(parameters={}) {
    return core.call({
      url: '/api/v1/external/issueAuthNo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  saveCustInfo(parameters={}) {
    return core.call({
      url: '/api/v1/external/saveCustInfo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  sendAuthMMS(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/sendAuthMMS',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  chkCustAuthInfo(parameters={}) {
    return core.call({
      url: '/api/v1/external/chkCustAuthInfo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  getCustBuyInfoList(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/getCustBuyInfoList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  getCountForDulCheck(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/getCountForDulCheck',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  getRecruitInfoList(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/getRecruitInfoList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  saveMyCustRecruit(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/saveMyCustRecruit',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  deleteCustRecruit(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/deleteCustRecruit',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  saveCustPrchHstr(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/saveCustPrchHstr',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  deleteCustPrchHstr(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/deleteCustPrchHstr',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  base(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/base',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  getBookCareList(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/getBookCareList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  getHomeclassList(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/getHomeclassList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },  
  selectLeanPrdList(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/selectLeanPrdList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  getLrnngInfrm(parameters={}) {
    return core.call({
      url: '/api/v1/external/getLrnngInfrm',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  getToken(parameters={}) {
    // 1. 현재 경로 수집
    const currentUrl = window.location.pathname;
    
    // 2. URL과 코드 매핑 사전 (WAP 넘버링 적용)
    const urlMap = {
        '/main': 'WP01',                                 // 홈
        '/eduplanmap/cart': 'WP02',                      // 에듀플랜맵 장바구니
        '/mypage/myEduInfor': 'WP03',                    // 내교육정보
        '/dashboard/profile': 'WP04',                    // 명함보기
        '/showRecoEvent': 'WP05',                        // 추천 이벤트
        '/myCstmr/myCstmrView': 'WP06',                  // 고객상세
        '/myCstmr/myCstmrReg': 'WP07',                   // 고객등록
        '/orgStatus/orgStatusView': 'WP08',              // 조직현황 상세
        '/orgStatus/orgStatusView/profileDetails': 'WP09'// 조직현황 프로필 상세
    };
    
    // 3. 사전에 있는 주소면 WAP 코드를, 사전에 등록 안 된 페이지면 '99'를 보냄
    parameters.gubun = urlMap[currentUrl] || 'WP99';

    return core.call({
      url: '/api/v1/mycstmr/getToken',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  custIntegrationList(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/custIntegrationList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  saveCustIntegration(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/saveCustIntegration',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  getCustMemo(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/getCustMemo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  updateCustMemo(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/updateCustMemo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
}
